module.exports = __webpack_public_path__ + "static/media/prev.9790dd96.svg";